<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <div
    id="production-popup"
    class="ol-popup"
  >
    <div
      id="popup-content"
      v-if="showpopup"
    >
      <v-card
        tile
        flat
      >
        <v-card-title class="pa-0 text-body-1 font-weight-bold">
          <v-container>
            <v-row>
              <v-col
                class="pa-0"
                :cols="10"
              >
              </v-col>
              <v-col
                class="pa-0 text-right"
                :cols="2"
              >
                <v-btn
                  icon
                  small
                  @click="closePopup"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-title>
        <v-card-text
          v-if="millingInfo"
          class="px-0 pt-0"
        >
          <b>{{ language.t('RoadProfiler.ProductionPopup.info') }}:</b><br>
          <span>{{ language.t('RoadProfiler.ProductionPopup.timestamp') }}: {{ generalInfo.timestamp }}</span><br>
          <span>{{ language.t('RoadProfiler.ProductionPopup.millingWidth') }}: {{ generalInfo.width }} m</span>
          <br>

          <b>{{ language.t('RoadProfiler.ProductionPopup.dataSend') }}:</b>
          <br>
          <span>{{ language.t('RoadProfiler.ProductionPopup.offsetLeft') }}: {{modelInfo.offsetLeft}} cm</span><br>
          <span>{{ language.t('RoadProfiler.ProductionPopup.offsetRight') }}: {{modelInfo.offsetRight}} cm</span><br>
          <br>
          <span>{{ language.t('RoadProfiler.ProductionPopup.left') }}:</span>
          <span>{{ modelInfo.drumLeftCm }} cm,</span>
          <span>{{ language.t('RoadProfiler.ProductionPopup.right') }}: </span>
          <span>{{ modelInfo.drumRightCm }} cm</span>
          <br>
          <span>{{ language.t('RoadProfiler.ProductionPopup.slope') }}: </span>
          <span>{{ modelInfo.slope }} %</span>
          <br>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    showpopup: false,
    popupExpanded: false,

    generalInfo: {
      timestamp: null,
      width: null,
    },
    modelInfo: {
      drumRightCm: null,
      drumLeftCm: null,
      slope: null,
      leftOffset: null,
      rightOffset: null
    },

    millingInfo: {
      drumRightCm: null,
      drumLeftCm: null,
      slope: null,
    },
  }),
  watch: {
    "language.locale"() { },
  },
  methods: {
    closePopup() {
      this.popupExpanded = false;
      this.showpopup = false;
      this.changeTitleCheck = false;
      this.$emit("closePopup");
    },
    getProductionData(data) {
      this.showpopup = true;
      this.generalInfo.timestamp = data.timestamp;
      this.generalInfo.width = data.workingWidth;

      this.modelInfo.drumRightCm = data.drumRight_Z_d * 100;
      if (this.modelInfo.drumRightCm) this.modelInfo.drumRightCm = this.modelInfo.drumRightCm.toFixed(1);
      this.modelInfo.drumLeftCm = data.drumLeft_Z_d * 100;
      if (this.modelInfo.drumLeftCm) this.modelInfo.drumLeftCm = this.modelInfo.drumLeftCm.toFixed(1);
      this.modelInfo.slope = data.slope_d;
      if (this.modelInfo.slope) this.modelInfo.slope = this.modelInfo.slope.toFixed(1);
      this.modelInfo.offsetLeft = data.offsetLeft * 100;
      if(this.modelInfo.offsetLeft) this.modelInfo.offsetLeft = this.modelInfo.offsetLeft.toFixed(1);
      this.modelInfo.offsetRight = data.offsetRight * 100;
      if(this.modelInfo.offsetRight) this.modelInfo.offsetRight = this.modelInfo.offsetRight.toFixed(1);

      this.millingInfo.drumRightCm = data.drumRight_Z * 100;
      if (this.millingInfo.drumRightCm) this.millingInfo.drumRightCm = this.millingInfo.drumRightCm.toFixed(1);
      this.millingInfo.drumLeftCm = data.drumLeft_Z * 100;
      if (this.millingInfo.drumLeftCm) this.millingInfo.drumLeftCm = this.millingInfo.drumLeftCm.toFixed(1);
      this.millingInfo.slope = Number(data.slope);
      if (this.millingInfo.slope) this.millingInfo.slope = this.millingInfo.slope.toFixed(1);

      console.log(this.generalInfo);
      console.log(this.modelInfo);
      console.log(this.millingInfo);
    },
  },
};
</script>
<style>
.ol-popup {
  position: absolute;
  background-color: white;
  -webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));
  filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));
  padding: 15px;
  border-radius: 10px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  min-width: 280px;
}

.ol-popup:after,
.ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}

.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}

.ol-popup-closer {
  text-decoration: none;
  position: absolute;
  top: 2px;
  right: 8px;
}

.ol-popup-closer:after {
  content: "x";
}
</style>